// Client error reporting: console.error + beacon to /api/client-error (stored server-side).
let sent = 0

/** @returns {string} best-effort WebGL renderer/version, to diagnose GPU/context problems */
function webglInfo() {
  try {
    const c = document.createElement('canvas')
    const gl = /** @type {WebGLRenderingContext | null} */ (c.getContext('webgl2') || c.getContext('webgl'))
    if (!gl) return 'no webgl'
    const ext = gl.getExtension('WEBGL_debug_renderer_info')
    return `${gl.getParameter(gl.VERSION)} | ${ext ? gl.getParameter(ext.UNMASKED_RENDERER_WEBGL) : 'n/a'}`
  } catch (e) {
    return `webgl probe failed: ${e}`
  }
}

/**
 * Log an error and send it to the server (max 5 per page load).
 * @param {string} kind short category, e.g. 'scene-update'
 * @param {unknown} err
 * @param {string} [context] extra detail (state, attempt, ...)
 */
export function reportError(kind, err, context = '') {
  console.error(kind, err)
  if (sent >= 5) return
  sent++
  try {
    const e = err instanceof Error ? err : new Error(String(err))
    const bundle = /** @type {HTMLScriptElement | null} */ (document.querySelector('script[src*="/build/app"]'))?.src
    const body = JSON.stringify({
      kind,
      message: e.message,
      stack: e.stack,
      url: location.href,
      bundle: bundle?.split('/').pop(),
      ua: navigator.userAgent,
      viewport: `${innerWidth}x${innerHeight}@${devicePixelRatio} vis=${document.visibilityState}`,
      webgl: webglInfo(),
      context,
    })
    navigator.sendBeacon('/api/client-error', new Blob([body], {type: 'application/json'}))
  } catch {
    /* reporting must never throw */
  }
}

/** Report uncaught errors and unhandled rejections too. */
export function installGlobalReporting() {
  addEventListener('error', e => reportError('window-error', e.error ?? e.message))
  addEventListener('unhandledrejection', e => reportError('unhandled-rejection', e.reason))
}
